import { TableWrapper } from '@bitstopco/bitstop-theme';
import { skipToken } from '@reduxjs/toolkit/query';
import { useRef, useState } from 'react';

import CardTable from '@/components/ui/card/CardTable';

import { DEFAULT_PAGINATION } from '@/constants/api';
import {
  RESTOCKING_MACHINES_COLUMNS,
  RESTOCKING_MACHINES_FILTERS_CONFIG,
} from '@/constants/app/restocking';

import { appendToFilters } from '@/helpers/api';
import { useGetMachinesQuery } from '@/store/api/services/machines/machines';

import type { Machine } from '@/types';
import type { ApiListingRequest, TableWrapperRef } from '@bitstopco/bitstop-theme';

const DEFAULT_BILL_DISPENSER_FILTER = {
  operator: 'equal',
  property: 'is_bill_dispenser_available',
  value: true,
};

const RestockingMachines = () => {
  const [payload, setPayload] = useState<ApiListingRequest>();
  const tableRef = useRef<TableWrapperRef>(null);

  const {
    data: {
      data: atmsData = [],
      meta: { pagination: metaPagination = DEFAULT_PAGINATION } = {},
    } = {},
    isFetching,
  } = useGetMachinesQuery(payload || skipToken);

  const handleFiltersChange = (value: ApiListingRequest) =>
    setPayload(appendToFilters(value, [DEFAULT_BILL_DISPENSER_FILTER]));

  return (
    <CardTable>
      <TableWrapper<Machine>
        data={atmsData}
        ref={tableRef}
        hideDateRangePicker
        hideActionMenu
        isLoading={isFetching || !payload}
        sortByDefaultValue="id"
        columns={RESTOCKING_MACHINES_COLUMNS}
        filterConfigs={RESTOCKING_MACHINES_FILTERS_CONFIG}
        totalPages={metaPagination?.total_pages}
        totalItems={metaPagination?.total_items}
        tableProps={{
          placeholder: {
            empty: {
              title: 'No machines found',
              content:
                "We can't find any machine that matches your search, please try a different request",
            },
          },
        }}
        tableToolbarProps={{ searchPlaceholder: "Search by machine's name, serial, and ID" }}
        onChange={handleFiltersChange}
      />
    </CardTable>
  );
};

export default RestockingMachines;
